'use client'

import { isNull } from 'lodash-es'
import { useEffect, useState } from 'react'

import { LikeButton } from '@/features/toggle-favorite-room'
import { CopyButton } from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = {
  roomId: number
  like: boolean
  showLikeButton?: boolean
  roomUrl: string | null
}
export const ActionButtons = ({
  roomId,
  like,
  showLikeButton = true,
  roomUrl,
}: Props) => {
  const hasRoomUrl = !isNull(roomUrl)

  const [currentUrl, setCurrentUrl] = useState('')

  const url =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'local' ? currentUrl : roomUrl

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  return (
    <ul className="flex h-6 items-center justify-end gap-3 px-4">
      {hasRoomUrl && (
        <li className="h-6">
          <CopyButton
            asChild
            value={url ?? ''}
            successMessage="링크가 복사되었습니다"
          >
            <button type="button" className="cursor-pointer">
              <Icon
                name="share"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
              <span className="sr-only">공유하기</span>
            </button>
          </CopyButton>
        </li>
      )}
      {showLikeButton && (
        <li className="h-6">
          <LikeButton
            variant="line"
            roomId={roomId}
            like={like}
            className="p-0"
          />
        </li>
      )}
    </ul>
  )
}
